export default {
  "common": {
    "accessManagement": "Gestão de Acesso",
    "action": "Ação",
    "actions": "Ações",
    "activate": "Reativar",
    "activate_field": "Reativar campo",
    "activate_field_confirmation": "O campo voltará a ser exibido no construtor, na exportação e na importação.",
    "activate_link": "Ativar link",
    "active": "Ativo",
    "add_as_role": "Adicionar como {{role}} ({{quantity}})",
    "add_column": "Adicionar coluna",
    "add_dependency": "Adicionar dependência",
    "add_field": "Adicionar campo",
    "add_group": "Adicionar Grupo",
    "add_group_feature_description": "Selecione o grupo que deseja adicionar a funcionalidade",
    "add_group_feature_title": "Adicionar grupo a funcionalidade",
    "add_initiative": "Adicionar iniciativa",
    "add_one_option_per_line": "Adicione uma opção por linha",
    "add_option": "Adicionar opção",
    "add_permission": "Adicionar permissão",
    "add_question": "Adicionar pergunta",
    "add_related_field": "Adicionar campo relacionado",
    "add_row": "Adicionar linha",
    "add_rule": "Adicionar regra",
    "add_section": "Adicionar seção",
    "add_to_group": "Adicionar a um grupo",
    "add_user": "Adicionar Usuário",
    "add_user_feature_description": "Selecione o usuário que deseja adicionar a funcionalidade",
    "add_user_feature_title": "Adicionar usuário a funcionalidade",
    "add_user_to_group": "Adicionar usuário ao grupo",
    "add_users_to_initiative": "Adicionar usuários à iniciativa",
    "add_workflow": "Adicionar Workflow",
    "added_at": "Adicionado em",
    "administrator": "Administrador",
    "administrator_role_description": "Acesso completo à iniciativa: configuração, funcionalidades, coletas, importações e exportações.",
    "alias": "Alias",
    "alias_format": "O alias deve conter apenas letras minúsculas, números ou underline",
    "alias_invalid_others_suffix": "O alias não pode terminar com \"_others\"",
    "alias_invalid_reserved_word": "Alias inválido. Não pode ser uma palavra reservada.",
    "alias_max_length": "O alias deve ter no máximo 100 caracteres",
    "alias_min_length": "O alias deve ter no mínimo 3 caracteres",
    "all": "Todas",
    "all_done": "Tudo pronto, obrigado!",
    "all_relations": "Todas",
    "allow_others": "Adicionar outros?",
    "allow_typed_signature": "Permitir assinatura digitada?",
    "already_has_permission": "já tem permissão: {{role}}",
    "and": "E",
    "annex_from_device": "Anexar do dispositivo",
    "anom_user": "Anônimo",
    "apply_filter": "Aplicar",
    "apply_filter_count_one": "Aplicar ({{count}})",
    "apply_filter_count_many": "Aplicar ({{count}})",
    "apply_filter_count_other": "Aplicar ({{count}})",
    "apply_rules": "Aplicar regras",
    "ascending_relations": "Ascendentes",
    "attributes": "Atributos",
    "audio_duration": "Duração do áudio",
    "audio_input_accepted_formats": "MP3, WAV, M4A ou OGG · máx. 10MB",
    "audio_input_delete_confirm_message": "Esta gravação será excluída permanentemente. Deseja continuar?",
    "audio_input_delete_confirm_title": "Excluir gravação?",
    "audio_input_discard_confirm_message": "Ao gravar novamente, o áudio atual será descartado. Deseja continuar?",
    "audio_input_discard_confirm_title": "Descartar gravação?",
    "audio_recording_too_long": "A gravação foi encerrada automaticamente em {{seconds}} segundos",
    "audio_recording_too_short": "A gravação deve ter pelo menos {{seconds}} segundos",
    "audio_uploading_helper_text": "Enviando áudio... não feche o formulário.",
    "audio_uploading_step_label": "Enviando",
    "authentication": "Autenticação",
    "back": "Voltar",
    "back_to_feature": "Voltar para Funcionalidade",
    "back_to_home": "Voltar para o início",
    "back_to_initiative": "Voltar para iniciativa",
    "batch_limit_reached": "Limite de {{max}} usuários por vez atingido.",
    "begins_with": "Começa com",
    "between": "Entre",
    "both_filters_cannot_be_empty": "Ambos os filtros não podem estar vazios",
    "building": "Em construção...",
    "business": "Negócio",
    "business_created_successfully": "Negócio criado com sucesso.",
    "business_data": "Dados do negócio",
    "business_name": "Nome do negócio",
    "business_required": "É necessário informar o nome do negócio",
    "business_updated_successfully": "Negócio atualizado com sucesso.",
    "businesses": "Negócios",
    "businesses_count_one": " · {{count}} negócio",
    "businesses_count_many": " · {{count}} negócios",
    "businesses_count_other": " · {{count}} negócios",
    "cancel": "Cancelar",
    "cannot_change_own_permission": "Não é possível alterar a própria permissão",
    "cannot_delete_group_with_users": "Você não pode deletar o grupo porque ele tem usuários",
    "cannot_remove_last_section": "Você não pode excluir a única seção.",
    "cannot_save_empty_filter": "Não é possível salvar um filtro vazio",
    "cannot_save_empty_form": "Não é possível salvar formulário vazio",
    "carousel_go_to_item": "Ir para o item {{index}}",
    "change_password": "Alterar senha",
    "change_permission": "Alterar permissão",
    "change_user_password": "Alterar senha do usuário",
    "change_user_password_description": "Crie uma senha temporária para o usuário, essa senha deverá ser trocada no próximo login.",
    "choose_an_attribute_from_the_list_above": "Escolha um campo da lista acima",
    "choose_field_from_table": "Escolha um campo da tabela de dados",
    "choose_layout_link": "Escolha o layout para o qual deseja criar o link:",
    "clean_unsaved_collect": "Limpar coleta não salva",
    "clear_filter": "Limpar",
    "click_here_to_view": "Abrir ou baixar em outra aba",
    "CNPJ_invalid": "O CNPJ informado é inválido.",
    "CNPJ_max_length_18": "O CNPJ deve ter no máximo 18 caracteres.",
    "CNPJ_min_length_18": "O CNPJ deve ter no mínimo 18 caracteres.",
    "CNPJ_required": "O CNPJ é obrigatório",
    "code_editor_collapsed_image": "imagem · {{size}} KB",
    "collapse_all": "Recolher tudo",
    "collect": "Coleta",
    "collect_already_registered": "Coleta já registrada.",
    "collect_back_button": "Anterior",
    "collect_concluded_button": "Concluir formulário",
    "collect_created_confirmation": "Deseja voltar para a listagem ou criar uma nova coleta?",
    "collect_created_title": "Coleta salva com sucesso",
    "collect_date_time": "{{date}} às {{hours}}h{{minutes}}",
    "collect_days_ago_one": "Há {{count}} dia",
    "collect_days_ago_many": "Há {{count}} dias",
    "collect_days_ago_other": "Há {{count}} dias",
    "collect_delete_in_use_description": "Esta coleta não pode ser excluída porque está sendo utilizada em outra funcionalidade.",
    "collect_delete_in_use_title": "Coleta em uso",
    "collect_hours_ago_one": "Há {{count}} hora",
    "collect_hours_ago_many": "Há {{count}} horas",
    "collect_hours_ago_other": "Há {{count}} horas",
    "collect_just_now": "Agora",
    "collect_minutes_ago_one": "Há {{count}} minuto",
    "collect_minutes_ago_many": "Há {{count}} minutos",
    "collect_minutes_ago_other": "Há {{count}} minutos",
    "collect_months_ago_one": "Há {{count}} mês",
    "collect_months_ago_many": "Há {{count}} meses",
    "collect_months_ago_other": "Há {{count}} meses",
    "collect_next_button": "Próxima seção",
    "collect_section_paginate": "Seção",
    "collect_section_paginate_separator": "de",
    "collect_versions": "Versões da coleta",
    "collect_years_ago_one": "Há {{count}} ano",
    "collect_years_ago_many": "Há {{count}} anos",
    "collect_years_ago_other": "Há {{count}} anos",
    "collect(s)": "Coleta(s)",
    "collected_by": "Coletado por {{name}}",
    "collects": "Coletas",
    "collects_count_one": "{{count}} coleta",
    "collects_count_many": "{{count}} coletas",
    "collects_count_other": "{{count}} coletas",
    "collects_label_one": "coleta",
    "collects_label_many": "coletas",
    "collects_label_other": "coletas",
    "collects_last_7_days": "Coletas 7d",
    "collects_point_to_this_one": "{{count}} coleta aponta para esta",
    "collects_point_to_this_many": "{{count}} coletas apontam para esta",
    "collects_point_to_this_other": "{{count}} coletas apontam para esta",
    "column_size": "Tamanho da coluna",
    "condition": "Condição",
    "condition_contains": "Contém",
    "condition_equal": "Igual",
    "condition_greater_than": "Maior que",
    "condition_less_than": "Menor que",
    "condition_multiple": "Múltiplo",
    "configurations": "Configurações",
    "configure": "Configurar",
    "configure_attribute": "Configurar atributo",
    "confirm": "Confirmar",
    "confirm_action": "Confirmar troca de status",
    "confirm_change_to_administrator": "O acesso de {{name}} será ampliado: ele passará a administrar a iniciativa, com acesso à configuração, às funcionalidades e às coletas.",
    "confirm_change_to_dashboard": "{{name}} perderá o acesso à configuração da iniciativa, às funcionalidades e às coletas, exceto pelos perfis que tiver diretamente em funcionalidades.",
    "confirm_delete_feature": "Tem certeza que deseja excluir esta funcionalidade?",
    "confirm_password": "Confirme a senha",
    "confirm_remove_dependencies_description": "Ao alterar este campo, as dependências atuais serão removidas. Tem certeza que deseja continuar?",
    "confirm_remove_permission": "Remover a permissão de {{name}} nesta iniciativa?",
    "confirm_remove_row_description": "Deseja realmente remover esta linha? Os campos contidos nela serão removidos.",
    "confirm_remove_section_description": "Deseja realmente remover esta seção? Os campos contidos nela serão removidos.",
    "confirm_update_field_in_published_layout": "Deseja realmente atualizar este campo?",
    "connect_question": "Conectar a pergunta",
    "consent_text_min_length": "O texto de consentimento deve ter no mínimo 5 caracteres.",
    "consent_text_required": "É necessário informar o texto de consentimento",
    "contact_initiative_administrator": "Procure o administrador da iniciativa.",
    "contains": "Contém",
    "contains_file": "Contém arquivo",
    "copy_default_view": "Copiar visualização padrão",
    "CPF_invalid": "O CPF informado é inválido.",
    "CPF_min_length_11": "O CPF deve ter no mínimo 11 caracteres.",
    "create": "Criar",
    "create_business": "Criar Negócio",
    "create_field": "Criar campo",
    "create_group": "Criar grupo",
    "create_initiative": "Criar iniciativa",
    "create_new_collect": "Criar nova coleta",
    "create_user": "Criar usuário",
    "created_at": "Criado em",
    "created_at_label": "Criado {{date}}",
    "created_by": "Criado por",
    "created_with": "Formulário criado com",
    "currency_symbol": "R$",
    "custom_fields": "Campos personalizados",
    "customize_layout_attributes": "Customizar layout e atributos",
    "dashboard": "Dashboard",
    "dashboard_link": "Link do dashboard",
    "dashboard_link_placeholder": "https://app.powerbi.com/exemplo",
    "dashboard_only_access_badge": "Acesso somente aos painéis analíticos",
    "dashboard_only_card_badge": "Somente dashboard — Acesso aos painéis analíticos",
    "dashboard_role_description": "Acesso somente aos painéis analíticos (Power BI). Não acessa funcionalidades, coletas, arquivos, mapa dos dados, importações nem exportações.",
    "data_collection": "Coleta de dados",
    "data_information": "Dados e informações",
    "data_map": "Mapa dos dados",
    "data_source": "Fonte de dados",
    "data_table": "Tabela de dados",
    "date_invalid": "A data deve estar no formato dd/mm/aaaa",
    "DateTime_invalid": "A data e hora devem estar no formato dd/mm/aaaa HH:mm",
    "deactivate": "Inativar",
    "deactivate_field": "Inativar campo",
    "deactivate_field_confirmation": "O campo deixará de aparecer no construtor, na exportação e na importação, mas o histórico das coletas será mantido.",
    "deactivate_link": "Desativar link",
    "default_view": "Visualização padrão",
    "define_super_admin_permissions": "Definir permissões de super admin",
    "delete": "Excluir",
    "delete_attribute": "Excluir atributo",
    "delete_collect": "Você realmente deseja deletar esta coleta?",
    "delete_dependency": "Excluir dependência",
    "delete_feature": "Excluir Funcionalidade",
    "delete_feature_confirmation_label": "Sim, eu entendo e quero deletar essa funcionalidade",
    "delete_feature_warning": "Atenção: Esta ação é irreversível. Todos os dados vinculados a esta funcionalidade serão removidos permanentemente.",
    "delete_initiative": "Deletar iniciativa",
    "delete_initiative_confirmation": "Deseja realmente excluir esta iniciativa?",
    "delete_option": "Deletar opção",
    "delete_permission": "Deletar permissão",
    "delete_permission_confirmation": "Você tem certeza que deseja excluir esta permissão?",
    "delete_workflow": "Excluir workflow",
    "delete_workflow_description": "Você tem certeza que deseja excluir este workflow?",
    "dependencies": "Dependências",
    "dependencies_count_one": "dependência ({{count}})",
    "dependencies_count_many": "dependências ({{count}})",
    "dependencies_count_other": "dependências ({{count}})",
    "descending_relations": "Descendentes",
    "description": "Descrição",
    "description_length_invalid": "A descrição deve ter entre 3 e 800 caracteres",
    "description_max_length": "A descrição deve ter no máximo 800 caracteres",
    "Description_max_length_3_800": "A descrição deve ter entre 3 e 800 caracteres",
    "description_min_length": "A descrição deve ter no mínimo 3 caracteres",
    "description_min_length_3_800": "Descrição deve ter no mínimo 3 caracteres e no máximo 800 caracteres",
    "description_required": "A descrição é obrigatória",
    "destination_initiative_required": "É necessário selecionar uma iniciativa de destino para duplicar.",
    "destination_required": "O destino é obrigatório",
    "disable_portfolio": "Desativar portfólio",
    "discard": "Descartar",
    "do_you_really_want_to_remove_the_email_template": "Deseja realmente excluir este template de e-mail?",
    "do_you_really_want_to_remove_the_group": "Deseja realmente remover o grupo?",
    "download": "Download",
    "download_template": "Download do Template",
    "draft_saved": "Rascunho salvo",
    "drag_and_drop_file": "Arraste e solte o arquivo",
    "drag_to_reorder": "Arraste para reordenar",
    "duplicate_feature": "Duplicar Funcionalidade",
    "duplicate_initiative": "Duplicar Iniciativa",
    "duplicate_section_title": "Já existe uma seção com este título.",
    "edit": "Edição",
    "edit_and_delete": "Edição e Exclusão",
    "edit_feature": "Editar Funcionalidade",
    "edit_initiative": "Editar iniciativa",
    "edit_portfolio": "Editar portfólio",
    "edit_user": "Editar usuário",
    "editGroup": "Editar grupo",
    "email": "Email",
    "email_body": "Corpo do email",
    "email_invalid": "Email inválido",
    "email_required": "Email é obrigatório",
    "email_template_body": "Corpo do e-mail (HTML)",
    "email_template_body_required": "Corpo do e-mail é obrigatório",
    "email_template_code": "Código",
    "email_template_compatibility_warning": "Alguns atributos e recursos de HTML/CSS podem não funcionar em todos os clientes de e-mail.",
    "email_template_create": "Novo template",
    "email_template_created_successfully": "Template de e-mail criado com sucesso",
    "email_template_data": "Dados do template de e-mail",
    "email_template_deleted_successfully": "Template de e-mail excluído com sucesso",
    "email_template_edit": "Editar template",
    "email_template_edited_successfully": "Template de e-mail atualizado com sucesso",
    "email_template_locale": "Idioma",
    "email_template_locale_placeholder": "Selecione o idioma",
    "email_template_locale_required": "Idioma é obrigatório",
    "email_template_missing_variables": "Variáveis obrigatórias ausentes: {{variables}}",
    "email_template_preview": "Pré-visualização",
    "email_template_preview_empty": "Preencha o corpo do e-mail para visualizar",
    "email_template_preview_feature_example": "Funcionalidade de exemplo",
    "email_template_subject": "Assunto",
    "email_template_subject_max_length": "Assunto deve ter no máximo {{maxLength}} caracteres",
    "email_template_subject_required": "Assunto é obrigatório",
    "email_template_unknown_variables": "Variáveis não permitidas: {{variables}}",
    "email_template_updated_at": "Atualizado em",
    "email_template_variable_optional": "Variável opcional",
    "email_template_variable_required_missing": "Variável obrigatória ausente",
    "email_template_variable_required_present": "Variável obrigatória presente",
    "email_template_variables": "Variáveis:",
    "email_templates": "Templates de e-mail",
    "email_templates_description": "Templates de e-mail usados pelos workflows desta iniciativa.",
    "empty_layout": "Layout vazio",
    "empty_section_title": "O título da seção não pode ser vazio",
    "enable_portfolio": "Ativar portfólio",
    "enabled_required": "É necessário informar se o usuário está ativo",
    "end": "Fim",
    "end_date": "Data final",
    "ends_with": "Termina com",
    "enter_email": "Insira o email",
    "enter_email_body": "Insira o corpo do email",
    "enter_field_description": "Digite uma descrição para o campo",
    "enter_field_name": "Digite o nome do campo",
    "enter_new_password": "Digite a nova senha",
    "enter_option_name": "Digite o nome da opção",
    "equals": "É igual a",
    "error": "Erro",
    "exampleEmail {{verb}} {{feature}}": "O seguinte email já é enviado por padrão, o que você escrever nesse campo será mandado ao fim dessa mensagem:\nUma coleta com o ID # foi {{verb}} para a funcionalidade {{feature}}.",
    "executed_at": "Executado em",
    "existing_permissions_hint": "Quem já tem permissão na iniciativa aparece desabilitado. Para mudar a permissão, use a tabela.",
    "exit": "Sair",
    "expand_all": "Expandir tudo",
    "export_ascending_relations": "Relacionamentos Ascendentes",
    "export_data": "Exportação de dados",
    "export_data_success": "Solicitação de exportação feita com sucesso.",
    "export_descending_relations": "Relacionamentos Descendentes",
    "export_files": "Exportar arquivos das coletas",
    "export_pdf": "Exportar PDF",
    "exports": "Exportações",
    "feature": "Funcionalidade",
    "feature_created_successfully": "Funcionalidade criada com sucesso.",
    "feature_data": "Dados da Funcionalidade",
    "feature_enabled": "Funcionalidade Ativa",
    "feature_name": "Nome da Funcionalidade",
    "feature_published": "Funcionalidade publicada",
    "feature_updated_error": "Erro ao atualizar funcionalidade",
    "feature_updated_success": "Funcionalidade atualizada com sucesso.",
    "features": "Funcionalidades",
    "field": "Campo",
    "field_activated_successfully": "Campo reativado com sucesso.",
    "field_created_successfully": "Campo criado com sucesso.",
    "field_deactivated_successfully": "Campo inativado com sucesso.",
    "field_description_max_length": "A descrição do campo deve ter no máximo 500 caracteres.",
    "field_name_max_length": "O nome do campo deve ter no máximo 250 caracteres.",
    "field_placeholder": "Campo...",
    "field_required": "O campo é obrigatório",
    "field_type_BIG_INT": "Número inteiro",
    "field_type_DATE": "Data",
    "field_type_DATETIME": "Data e hora",
    "field_type_DECIMAL": "Número decimal",
    "field_type_FILE": "Arquivo",
    "field_type_GEOGRAPHICAL_MULTIPLE_POINT": "Múltiplos pontos geográficos",
    "field_type_GEOGRAPHICAL_POINT": "Ponto geográfico",
    "field_type_GEOGRAPHICAL_POLYGON": "Polígono geográfico",
    "field_type_GEOGRAPHICAL_ROUTE": "Rota geográfica",
    "field_type_IMPORT_FIELD": "Importar uma funcionalidade",
    "field_type_INFO_TEXT": "Texto informativo",
    "field_type_LONG_TEXT": "Texto longo",
    "field_type_MATRIZ": "Matriz",
    "field_type_MULTIPLE_LIST": "Caixa de seleção múltipla",
    "field_type_required": "É necessário informar o tipo do campo",
    "field_type_TERM": "Termo de consentimento",
    "field_type_TEXT": "Texto curto",
    "field_type_TIME": "Hora",
    "field_type_UNIQUE_LIST": "Caixa de seleção única",
    "field_updated_successfully": "Campo atualizado com sucesso.",
    "fields_filter_active": "Ativos",
    "fields_filter_all": "Todos",
    "fields_filter_inactive": "Inativos",
    "fields_to_export": "Campos a serem exportados",
    "file": "Arquivo",
    "file_cannot_be_null_select_file": "O arquivo não pode ser nulo. Por favor, selecione um arquivo para upload.",
    "file_name": "Nome do arquivo",
    "file_preview_not_supported": "Não é possível visualizar o arquivo",
    "file_too_large": "Arquivo grande demais para envio.",
    "filter_business": "Filtrar por negócio",
    "filter_by_feature": "Filtrar por Funcionalidade",
    "finish": "Finalizar",
    "finished_count": "Finalizadas",
    "finished_rate": "Taxa de Finalização",
    "form_answered_successfully": "Sua resposta do formulário <b>{{featureName}}</b> foi enviada com sucesso e já está registrada.",
    "full_screen": "Tela cheia",
    "generate_autoapply": "Gerar autoaplicação",
    "generate_link": "Gerar link",
    "generated_automatically": "Gerado automaticamente",
    "go_to_collects_list": "Voltar para a listagem",
    "go_to_decisio": "Ir para o Decisio",
    "go_to_initiative_dashboard": "Ir para o painel da iniciativa",
    "greater_than_or_equal_to": "Maior ou igual a",
    "group": "Grupo",
    "group_added_successfully": "Grupo adicionado com sucesso.",
    "group_created_successfully": "Grupo criado com sucesso.",
    "group_data": "Dados do grupo",
    "group_deleted_successfully": "Grupo excluído com sucesso.",
    "group_edited_successfully": "Grupo editado com sucesso.",
    "group_name": "Nome do grupo",
    "group_required": "O grupo é obrigatório",
    "groups": "Grupos",
    "if_the_answer_is": "Se a resposta for",
    "image_exceeded_size_limit": "A imagem excedeu o limite de tamanho de {{size}}mb.",
    "image_gallery": "Galeria de Imagens",
    "import_data_success": "Importação de dados realizada com sucesso.",
    "import_file": "Arquivo de importação",
    "import_finish": "Concluir",
    "import_line_max_length": "As linhas devem ter no máximo 255 caracteres.",
    "import_options": "Importar opções",
    "imported_data": "Importação de dados",
    "imports": "Importações",
    "in_seconds": "Em segundos",
    "inactive": "Inativo",
    "info_text_min_length": "O texto de informação deve ter no mínimo 5 caracteres.",
    "info_text_required": "É necessário informar a descrição do campo",
    "initiative": "Iniciativa",
    "initiative_access_removed": "Seu acesso a esta iniciativa foi removido",
    "initiative_created_successfully": "Iniciativa criada com sucesso.",
    "initiative_deleted_successfully": "Iniciativa excluída com sucesso.",
    "initiative_edited_successfully": "Iniciativa editada com sucesso.",
    "initiative_features": "Funcionalidades da iniciativa",
    "initiative_imports_and_exports": "Importações e exportações",
    "initiative_imports_and_exports_description": "Carregue dados ou extraia as coletas em XLSX.",
    "initiative_name": "Nome da iniciativa",
    "initiative_name_max_length": "O nome da iniciativa deve ter no máximo 50 caracteres.",
    "initiative_successfully_duplicated": "Iniciativa duplicada com sucesso.",
    "initiatives": "Iniciativas",
    "initiatives_count_one": "{{count}} iniciativa",
    "initiatives_count_many": "{{count}} iniciativas",
    "initiatives_count_other": "{{count}} iniciativas",
    "integer_invalid": "O valor informado deve ser um número inteiro.",
    "internal_collect": "Coleta interna",
    "internal_collect_back_to_initiative": "Voltar para a iniciativa",
    "internal_collect_conflict_retry": "A configuração foi alterada por outra pessoa. Confira e tente novamente.",
    "internal_collect_feature": "Funcionalidade da coleta interna",
    "internal_collect_no_access": "Você não tem acesso à coleta interna desta iniciativa.",
    "internal_collect_no_eligible_features": "Nenhuma funcionalidade elegível: ela precisa estar habilitada e com layout Web publicado.",
    "internal_collect_saved": "Coleta interna salva com sucesso.",
    "internal_collect_sent": "Coleta enviada com sucesso.",
    "internal_collect_unavailable": "Coleta interna indisponível.",
    "invalid_email": "E-mail inválido",
    "invalid_option": "Opção inválida",
    "language_en": "Inglês",
    "language_es": "Espanhol",
    "language_pt_br": "Português (Brasil)",
    "last_collect": "Última coleta",
    "last_collects": "Últimas coletas",
    "last_collects_load_error": "Não foi possível carregar as últimas coletas",
    "layout_saved_successfully": "Layout salvo com sucesso.",
    "less_than_or_equal_to": "Menor ou igual a",
    "like_required": "O termo de pesquisa é obrigatório",
    "link": "Vincular",
    "link_collect": "Vincular coleta",
    "link_feature": "Vincular funcionalidade",
    "link_features": "Vincular funcionalidades",
    "link_invalid": "Link inválido",
    "linked_features": "Funcionalidades vinculadas",
    "load_more": "Carregar mais",
    "load_more_collects_one": "Carregar mais {{count}} de {{total}}",
    "load_more_collects_many": "Carregar mais {{count}} de {{total}}",
    "load_more_collects_other": "Carregar mais {{count}} de {{total}}",
    "load_more_results": "Carregar mais resultados",
    "loading_layout": "Carregando Layout...",
    "loading_more": "Carregando...",
    "location": "Localização",
    "logo": "Logo",
    "logo_required": "O logo é obrigatório",
    "lookup": "Pesquisa",
    "main_fields": "Campos principais",
    "main_tab": "Principal",
    "manage_groups_permissions": "Gerencie os grupos que possuem permissões sobre essa funcionalidade.",
    "manage_users_permissions": "Gerencie os usuários que possuem permissões sobre essa funcionalidade.",
    "matrices": "Matrizes",
    "matrix": "Matriz",
    "matrix_fields": "Campos da matriz",
    "matriz_field": "Campo Matriz",
    "matriz-create": "Criar matriz",
    "matriz-delete": "Deletar matriz",
    "matriz-update": "Atualizar matriz",
    "max_duration": "Duração máxima",
    "max_duration_cannot_be_greater_than_600": "A duração máxima não pode ser maior que 600 segundos",
    "maximum_value": "Valor máximo",
    "menu_logout_confirm_description": "Você sairá da sua conta e qualquer alteração não salva será perdida. Deseja continuar?",
    "menu_logout_confirm_title": "Sair do Decisio",
    "microphone_access_denied": "O acesso ao microfone foi negado. Por favor, permita o acesso ao microfone para gravar áudio.",
    "min_duration": "Duração mínima",
    "min_value_cannot_be_greater_than_max_value": "O valor mínimo não pode ser maior que o valor máximo",
    "minimum_value": "Valor mínimo",
    "mobile": "Mobile",
    "monetary_subtype_not_apply_to_text": "O subtipo monetário não se aplica a texto",
    "more_fields_one": "+ {{count}} campo",
    "more_fields_many": "+ {{count}} campos",
    "more_fields_other": "+ {{count}} campos",
    "more_filled_fields_one": "+ {{count}} campo preenchido",
    "more_filled_fields_many": "+ {{count}} campos preenchidos",
    "more_filled_fields_other": "+ {{count}} campos preenchidos",
    "most_recent": "Mais recentes",
    "name": "Nome",
    "name_max_length": "Nome deve ter no máximo {{maxLength}} caracteres",
    "name_min_length": "Nome deve ter no mínimo 3 caracteres",
    "name_min_length_3": "O nome deve ter no mínimo 3 caracteres",
    "name_required": "Nome é obrigatório",
    "new_collect": "Nova coleta",
    "new_collect_no_layout": "Nenhum layout publicado e permitido na funcionalidade de destino",
    "new_export": "Nova exportação",
    "new_feature": "Nova funcionalidade",
    "new_import": "Nova importação",
    "next": "Próximo",
    "no": "Não",
    "no_access_to_area": "Você não tem acesso a esta área",
    "no_attribute_selected": "Nenhum atributo selecionado",
    "no_audits_found": "Nenhuma auditoria encontrada.",
    "no_businesses_found": "Nenhum negócio encontrado",
    "no_collect_found": "Nenhuma coleta encontrada",
    "no_collect_links": "Não existem links de coleta para essa funcionalidade. Voltando...",
    "no_collects": "Sem coletas",
    "no_dashboard_available_yet": "Nenhum painel disponível ainda",
    "no_data_found": "Nenhum dado encontrado.",
    "no_email_templates_found": "Nenhum template de e-mail encontrado.",
    "no_exports_found": "Nenhuma exportação encontrada.",
    "no_features_found": "Nenhuma funcionalidade encontrada.",
    "no_fields_found": "Nenhum campo encontrado",
    "no_group_permission": "Nenhum grupo tem permissão para essa funcionalidade.",
    "no_groups_found": "Nenhum grupo encontrado",
    "no_imports_found": "Nenhuma importação encontrada.",
    "no_initiatives_found": "Nenhuma iniciativa encontrada",
    "no_linked_features": "Nenhuma funcionalidade vinculada",
    "no_permission": "Sem permissão",
    "no_published_layout_redirect": "Não há nenhum layout publicado para essa funcionalidade. Redirecionando...",
    "no_records_found": "Nenhum registro encontrado",
    "no_related_fields_found": "Nenhum campo relacionado encontrado",
    "no_user_permission": "Nenhum usuário tem permissão para essa funcionalidade.",
    "no_users_found": "Nenhum usuário encontrado",
    "no_workflows_found": "Nenhum workflow encontrado",
    "none": "Nenhum",
    "not_authorized": "Acesso não autorizado!",
    "not_collect_found": "Nenhuma coleta encontrada.",
    "not_contains": "Não contém",
    "not_equals": "Não é igual a",
    "notification": "Notificação",
    "on_change_section": "Ao alterar a matriz de referência ou o tipo de seção, as configurações atuais serão perdidas. Tem certeza?",
    "on_close": "Fechar",
    "only_audio_files": "Somente arquivos de áudio são permitidos",
    "only_images_allowed": "Somente imagens são permitidas",
    "only_images_as_logo": "O negócio aceita apenas imagens do tipo .png, .jpeg, .gif ou .webapp como logo.",
    "open": "Abrir",
    "open_collect": "Abrir coleta",
    "open_count": "Aberturas",
    "open_dashboard": "Abrir painel",
    "open_in_power_bi": "Abrir no Power BI",
    "open_initiative": "Abrir iniciativa",
    "operator": "Operador",
    "operator_required": "O operador é obrigatório",
    "option_line_placeholder": "opção 1",
    "option_name_required": "O nome da opção é obrigatório",
    "or": "OU",
    "order": "Ordenação",
    "order_by": "Ordenar por",
    "other": "Outros",
    "page_not_found": "Página não encontrada",
    "page_not_found_description": "A página que você está procurando não existe.",
    "pagination": "Paginação",
    "participants": "Participantes",
    "password": "Senha",
    "password_changed_successfully": "Senha alterada com sucesso.",
    "password_max_length": "Senha deve ter no máximo 40 caracteres",
    "password_min_length": "Senha deve ter no mínimo 4 caracteres",
    "password_required": "Senha é obrigatória",
    "passwords_must_match": "As senhas devem ser iguais",
    "past": {
      "create": "criada",
      "delete": "deletada",
      "update": "atualizada"
    },
    "pause": "Pausar",
    "paused_status": "Pausado",
    "permission": "Permissão",
    "permission_added_success": "Permissão adicionada com sucesso.",
    "permission_deleted_successfully": "Permissão excluída com sucesso.",
    "permission_removed_successfully": "Permissão removida com sucesso.",
    "permission_role_changed_successfully": "Permissão alterada com sucesso.",
    "permissions": "Permissões",
    "permissions_added_successfully": "Permissões adicionadas com sucesso ({{quantity}}).",
    "permissions_groups": "Permissões de Grupos",
    "permissions_tab_description": "Gerencie os papéis dos usuários nesta iniciativa.",
    "permissions_user": "Permissões de Usuários",
    "Phone_max_length_15": "O telefone deve ter no máximo 15 caracteres.",
    "Phone_min_length_14": "O telefone deve ter no mínimo 14 caracteres.",
    "placeholder_editor": "Digite ou cole seu conteúdo aqui!",
    "platform": "Plataforma",
    "platform_required": "É necessário informar a plataforma",
    "Point_invalid": "O valor informado deve ser um número.",
    "Point_invalid_range": "O valor informado deve estar entre 0 e 100.",
    "point_min_length_1": "Deve ser informado pelo menos um ponto",
    "portfolio": "Portfólio",
    "positive_invalid": "Número deve ser positivo",
    "power_bi": "Power BI",
    "preview_fields": "Campos de pré-visualização",
    "previous": "Anterior",
    "processing": "Processando",
    "publish": "Publicar",
    "recent": "Recentes",
    "record_audio": "Gravar áudio",
    "recorded_now": "Gravado agora",
    "recording_status": "Gravando",
    "region_city_or_neighborhood ": "Região, cidade ou bairro",
    "registration": "Cadastro",
    "related_field": "Campo relacionado",
    "relationships": "Relacionamentos",
    "remove": "Remover",
    "remove_permission": "Remover permissão",
    "remove_rule": "Remover regra",
    "remove_user": "Remover usuário",
    "remove_user_from_group": "Remover usuário do grupo",
    "required_field": "Campo obrigatório?",
    "required_matrix": "Matriz obrigatória?",
    "response": "Resposta",
    "response_value": "Valor de resposta",
    "responsible_data": "Dados do responsável",
    "responsible_email": "E-mail do responsável",
    "Responsible_email_invalid": "O e-mail do responsável é inválido",
    "Responsible_email_required": "O e-mail do responsável é obrigatório",
    "responsible_name": "Nome do responsável",
    "responsible_name_max_length": "O nome do responsável deve ter no máximo 255 caracteres.",
    "Responsible_name_max_length_100": "O nome do responsável deve ter no máximo 100 caracteres.",
    "responsible_name_min_length": "O nome do responsável deve ter no mínimo 3 caracteres.",
    "Responsible_name_min_length_3": "O nome do responsável deve ter no mínimo 3 caracteres.",
    "Responsible_name_required": "O nome do responsável é obrigatório",
    "responsible_phone": "Telefone do responsável",
    "responsible_phone_max_length": "O telefone do responsável deve ter no máximo 15 caracteres.",
    "Responsible_phone_max_length_15": "O telefone do responsável deve ter no máximo 15 caracteres.",
    "responsible_phone_min_length": "O telefone do responsável deve ter no mínimo 14 caracteres.",
    "Responsible_phone_min_length_15": "O telefone do responsável deve ter no mínimo 14 caracteres.",
    "Responsible_phone_required": "O telefone do responsável é obrigatório",
    "restore_unsaved_collect": "Foi encontrada uma coleta não salva. Deseja restaurá-la?",
    "resume": "Retomar",
    "return_previous_page": "Voltar para página anterior",
    "return_to_businesses_management": "Voltar para gestão de negócios",
    "return_to_destination": "Voltar para {{destination}}",
    "return_to_email_templates": "Voltar para templates de e-mail",
    "return_to_group_management": "Voltar para gerenciamento de grupos",
    "return_to_initiative": "Voltar para iniciativa",
    "return_to_initiative_management": "Voltar para gerenciamento de iniciativas",
    "return_to_initiatives": "Voltar para iniciativas",
    "return_to_initiatives_management": "Voltar para gerenciamento de iniciativas",
    "return_to_user_management": "Voltar para gerenciamento de usuários",
    "save": "Salvar",
    "save_changes": "Salvar alterações",
    "saved": "Salvo",
    "saving": "Salvando...",
    "search_available_when_loaded": "Busca disponível ao terminar",
    "search_businesses": "Pesquisar negócios",
    "search_by_code_or_label": "Buscar por código ou label",
    "search_by_name_or_email": "Buscar por nome ou e-mail",
    "search_collects": "Pesquisar coletas",
    "search_collects_error": "Não foi possível carregar os resultados da busca",
    "search_collects_subtitle_one": "Encontradas em {{count}} funcionalidade",
    "search_collects_subtitle_many": "Encontradas em {{count}} funcionalidades",
    "search_collects_subtitle_other": "Encontradas em {{count}} funcionalidades",
    "search_collects_title_one": "{{count}} coleta para “{{search}}”",
    "search_collects_title_many": "{{count}} coletas para “{{search}}”",
    "search_collects_title_other": "{{count}} coletas para “{{search}}”",
    "search_features": "Pesquisar Funcionalidades",
    "search_fields": "Pesquisar campos",
    "search_groups": "Pesquisar grupos",
    "search_in_initiative": "Pesquisar na iniciativa",
    "search_initiative": "Pesquisar iniciativa",
    "search_min_length": "Digite ao menos {{min}} caracteres para buscar",
    "search_question": "Buscar pergunta",
    "search_users": "Pesquisar usuários",
    "second_value_required": "Segundo valor é obrigatório",
    "section": "Seção",
    "section_has_invalid_fields": "A seção possui campos inválidos.",
    "section_image": "Imagem da seção",
    "section_order_title": "Seção {{order}}",
    "section_required": "A seção é obrigatória",
    "section_title": "Título da seção",
    "sections": "Seções",
    "see_in_collect": "Ver na coleta",
    "select": "Selecionar",
    "select_a_feature": "Selecionar uma funcionalidade",
    "select_a_value": "Selecionar um valor",
    "select_action_type": "Selecione o tipo da ação",
    "select_all": "Selecionar todos",
    "select_an_import_file": "Selecionar um arquivo de importação",
    "select_an_option": "Selecionar uma opção",
    "select_at_least_one_item": "Selecione pelo menos um item",
    "select_at_least_one_option": "Selecione pelo menos uma opção",
    "select_attribute": "Selecionar atributo",
    "select_collect_required": "É necessário selecionar uma coleta",
    "select_condition": "Selecione uma condição",
    "select_condition_required": "É necessário selecionar uma condição",
    "select_feature": "Selecione uma funcionalidade",
    "select_feature_required": "É necessário selecionar uma funcionalidade",
    "select_features_to_link": "Você pode selecionar até 3 campos dessa funcionalidade para gerar uma pré-visualização da coleta a ser vinculada.",
    "select_field": "Selecione um campo",
    "select_field_min_options": "O campo de seleção deve ter no mínimo duas opções.",
    "select_field_subtype": "Selecione o subtipo",
    "select_field_type": "Selecione o tipo do campo",
    "select_filters": "Selecionar filtros",
    "select_group_placeholder": "Selecione um grupo",
    "select_group_required": "É necessário selecionar um grupo",
    "select_initiative": "Selecione uma iniciativa",
    "select_initiative_required": "É necessário selecionar uma iniciativa",
    "select_matriz_field": "Selecione o campo matriz",
    "select_max_three_fields": "Selecione no máximo 3 campos",
    "select_permission": "Selecione a permissão",
    "select_permission_level": "Selecione o nível de permissão",
    "select_platform_required": "É necessário selecionar uma plataforma",
    "select_preview_fields_tooltip": "Selecione os campos que deseja exibir na pré-visualização",
    "select_the_group_you_want_to_add_the_user_to": "Selecione o grupo que deseja adicionar o usuário",
    "select_user": "Selecione o usuário",
    "select_user_placeholder": "Selecione um usuário",
    "select_user_required": "É necessário selecionar um usuário",
    "select_user_to_add_to_group": "Selecione o usuário que deseja adicionar ao grupo",
    "selected_count_one": "{{count}} selecionado",
    "selected_count_many": "{{count}} selecionados",
    "selected_count_other": "{{count}} selecionados",
    "selected_items": "itens selecionados",
    "self_applied_link": "Link de Autoaplicação",
    "self_applied_session_expired": "Sua sessão expirou. Abra o link novamente e informe um novo código para continuar.",
    "send_new_answer": "Enviar nova resposta",
    "sensitive_data": "Dado sensível",
    "shared_preference": "Mudar para preferências do usuário",
    "show_less": "Mostrar menos",
    "show_more_count_one": "Mostrar mais {{count}}",
    "show_more_count_many": "Mostrar mais {{count}}",
    "show_more_count_other": "Mostrar mais {{count}}",
    "showing_initiatives_one": "Mostrando {{loaded}} de {{count}} iniciativa",
    "showing_initiatives_many": "Mostrando {{loaded}} de {{count}} iniciativas",
    "showing_initiatives_other": "Mostrando {{loaded}} de {{count}} iniciativas",
    "signature_add_title": "Adicionar assinatura",
    "signature_clear": "Limpar",
    "signature_consent_desktop": "Declaro que esta é a minha assinatura eletrônica e concordo em utilizá-la para assinar este formulário.",
    "signature_date_label": "Data",
    "signature_description": "Assine com o mouse, com o toque na tela ou digite seu nome completo.",
    "signature_description_no_typed": "Assine com o mouse ou com o toque na tela.",
    "signature_draw_above_line": "Assine acima da linha",
    "signature_empty_subtitle": "PNG gerado automaticamente e anexado à resposta",
    "signature_empty_title": "Nenhuma assinatura registrada",
    "signature_full_name": "Nome completo",
    "signature_full_name_document_placeholder": "Como consta no documento",
    "signature_image_alt": "Assinatura",
    "signature_location_label": "Local",
    "signature_name_label": "Nome",
    "signature_name_too_long": "Nome deve ter no máximo 255 caracteres",
    "signature_name_too_short": "Nome deve ter no mínimo 3 letras",
    "signature_redo": "Refazer",
    "signature_remove": "Remover",
    "signature_remove_confirm_message": "Esta assinatura será removida permanentemente. Deseja continuar?",
    "signature_remove_confirm_title": "Remover assinatura?",
    "signature_sample_name": "Seu nome",
    "signature_sign": "Assinar",
    "signature_tab_draw": "Desenhar",
    "signature_tab_type": "Digitar",
    "start": "Inicio",
    "start_date": "Data inicial",
    "start_date_cannot_be_greater_than_end_date": "A data de início não pode ser maior que a data de fim",
    "start_write_count": "Iniciadas",
    "status": "Status",
    "status_feature_updated_successfully": "Status da funcionalidade {{featureName}} atualizado com sucesso",
    "strict_section_navigate": "Navegação estrita entre seções",
    "sub_type": "Subtipo",
    "subtype_AUDIO": "Áudio",
    "subtype_CNPJ": "CNPJ",
    "subtype_CPF": "CPF",
    "subtype_HIPERLINK": "Link",
    "subtype_MAIL": "E-mail",
    "subtype_MONEY_VALUE": "Valor monetário",
    "subtype_PHONE": "Telefone",
    "subtype_SIGNATURE": "Assinatura",
    "subtypes_not_apply_to_decimal": "O subtipos não se aplicam a decimal",
    "success": "Sucesso",
    "successfully_duplicated": "Duplicado com sucesso",
    "successfully_removed": "Removido com sucesso",
    "summary_active_collectors": "Coletores ativos",
    "summary_files": "Arquivos",
    "summary_files_description": "anexos e áudios enviados",
    "summary_in_last_7_days": "nos últimos 7 dias",
    "summary_last_7_days": "Últimos 7 dias",
    "summary_last_collect_at": "última às {{time}}",
    "summary_no_collects_today": "nenhuma coleta hoje",
    "summary_today": "Hoje",
    "summary_total_collects": "Coletas totais",
    "summary_vs_previous_month": "{{value}} vs. mês anterior",
    "summary_vs_previous_week": "{{value}} vs. semana anterior",
    "super_admin": "Super administrador",
    "super_admin_business_required": "Informe o nível de permissão do negócio",
    "super_admin_initiative_required": "Informe o nível de permissão da iniciativa",
    "super_admin_permissions": "Permissões de super admin",
    "super_admin_required": "É necessário informar se o usuário é super administrador",
    "super_admin_user_required": "Informe o nível de permissão do usuário",
    "sync_explanation": "Ao sincronizar, você substitui suas preferências atuais pelas preferências padrão.",
    "sync_preference_unavailable": "Você já tem as preferências padrão",
    "template": "Template",
    "template_and_import": "Template e importação",
    "text_max_length_255": "O texto deve ter no máximo 255 caracteres.",
    "text_max_length_3000": "O texto deve ter no máximo 3000 caracteres.",
    "text_min_length_1": "O texto deve ter no mínimo 1 caractere.",
    "text_min_length_3": "O texto deve ter no mínimo 3 caracteres.",
    "this_action_cannot_be_undone": "Essa ação não pode ser desfeita.",
    "time_format_expected": "Formato de hora inválido",
    "Time_invalid": "Hora inválida",
    "title_initiative_data": "Dados da iniciativa",
    "too_many_requests_wait": "Muitas requisições. Aguarde alguns instantes e tente novamente.",
    "totp_error": "Código inválido",
    "totp_instruction": "Insira o código de autenticação",
    "trigger": "Gatilho",
    "trigger_type": "Tipo de Gatilho",
    "trigger_type_required": "O tipo de gatilho é obrigatório",
    "type": "Tipo",
    "type_required": "O tipo é obrigatório",
    "update": "Atualizar",
    "update_version": "Atualizar versão",
    "update_version_confirm_description": "Tem certeza que deseja atualizar a versão da funcionalidade? Esta ação poderá adicionar novas validações ou remover campos previamente cadastrados.",
    "updated_at_label": "Modificado {{date}}",
    "upload": "Upload",
    "user": "Usuário",
    "user_added_successfully": "Usuário adicionado com sucesso.",
    "user_created_successfully": "Usuário criado com sucesso.",
    "user_data": "Dados do usuário",
    "user_edited_successfully": "Usuário editado com sucesso.",
    "user_preference": "Mudar para preferências padrão",
    "user_profile": "Perfil do usuário",
    "user_removed_from_group_successfully": "Usuário removido do grupo com sucesso.",
    "user_required": "O usuário é obrigatório",
    "user_status": "Status do usuário",
    "users": "Usuários",
    "users_found": "Nenhum usuário encontrado",
    "valid_link_required": "É necessário informar um link válido",
    "valid_powerbi_link_required": "É necessário informar um link válido do Power BI",
    "value": "Valor",
    "value_must_be_a_number": "O valor deve ser um número",
    "value_required": "É necessário informar um valor",
    "version": "Versão",
    "video_tag_not_supported": "Exibição de vídeo não suportada",
    "view": "Visualização",
    "view_analytics": "Visualizar estatísticas",
    "view_version": "Visualizar Versão",
    "view_workflow": "Visualizar workflow",
    "visualizer_error": "Erro ao exibir o visualizador de áudio",
    "waiting": "Aguardando",
    "waveform_error": "Erro ao gerar a forma de onda do áudio",
    "web": "Web",
    "workflow_deleted_successfully": "Workflow excluído com sucesso",
    "workflows": "Workflows",
    "yes": "Sim",
    "you_can_create_link": "Você pode criar um link público para coletar respostas de forma online."
  },
  "initiative": {},
  "features": {},
  "translation": {}
} as const;
